
<body>
    <!-- partial:index.partial.html -->
    <main>
      <table class="calendar">
        <caption class="calendar__banner--month">
          <div style="width: 90%; left: 5%; text-align: center; align-items: center; align-content: center;">
            <mat-icon class="s-32 secondary-text" style="cursor: pointer; background-color: #0b84dc; color: white; margin-right: 5px; border-radius: 8px;" (click)="menos()" >arrow_left</mat-icon>
            <h1>{{ meses[mesActual] }} {{yearActual }}</h1>
            <mat-icon class="s-32 secondary-text" style="cursor: pointer; background-color: #0b84dc; color: white; margin-left: 5px; border-radius: 8px;" (click)="mas()" >arrow_right</mat-icon>

          </div>
          <span style="float: right;">
            <mat-icon class="s-24 secondary-text" style="cursor: pointer; color: #0b84dc;" (click)="refrescar()" >refresh</mat-icon>
          </span>
        </caption>
        <thead>
          <tr>
            <th class="calendar__day__header">Lun</th>
            <th class="calendar__day__header">Mars</th>
            <th class="calendar__day__header">Mie</th>
            <th class="calendar__day__header">Jue</th>
            <th class="calendar__day__header">Vie</th>
            <th class="calendar__day__header">Sab</th>
            <th class="calendar__day__header">Dom</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let semana of semanas">
            <td *ngFor="let dia of semana.dias" class="calendar__day__cell">
                {{ dia.dia}}
                <div class="numero" (click)="showReservas(dia)">
                    {{ dia.estado > 0 ? dia.estado : ''}}
                </div>
            </td>
          </tr>
        </tbody>
      </table>
    </main>
    <!-- partial -->
      
    </body>
    
    